// Main/root router definition// src/app/routing/index.ts
import { createRouter, Route } from '@tanstack/react-router';
import { rootRoute } from './rootRoute';
import { authRoutes } from '@/features/auth/routes';
import { dashboardRoute } from '@/features/dashboard/routes';
import { managementRoutes } from '@/features/management/routes';
import { medicalServicesRoutes } from '../../features/medicalServices/routes';
import { insurancePlanRoutes } from '../../features/insurancePlan/routes';
import { lookupRoutes } from '../../features/Lookup/routes';
import { participantsRoutes } from '../../features/participants/routes';
import { policiesRoutes } from '../../features/policies/routes';
import { providersRoutes } from '../../features/providers/routes';
import { salesPersonRoutes } from '../../features/salesPerson/routes';
import { icdRoutes } from '../../features/ICD/routes';
import { invoiceRoutes } from '../../features/Invoice/routes';
import { claimRouteRoutes } from '../../features/claim/routes';
import { customerRoutes } from '../../features/customers/routes';
import { auditLogRouteRoutes } from '../../features/auditLog/routes';
import NotAuthorizedPage from '@/common/pages/NotAuthorizedPage';

// Redirect from `/` to `/auth/login`
const indexRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: ({ navigate }) => {
    navigate({ to: '/auth/login', replace: true });
  },
  component: () => null,
});
// Import feature-specific route files

// import { employeesRoutes } from '../../features/employees/routes';
// import { dashboardRoutes } from '../../features/dashboard/routes';
// ... and so on for other features

// Create the router instance
export const router = createRouter({
  routeTree: rootRoute.addChildren([
    // Add feature-specific route trees here
    // Example: authRoutes are children of the root route
      indexRoute,    // ✅ This line includes the redirect route
       ...authRoutes, // other routes
      dashboardRoute,
      ...managementRoutes,
      ...medicalServicesRoutes,
      ...insurancePlanRoutes,
      ...lookupRoutes,
      ...participantsRoutes,
      ...policiesRoutes,
      ...providersRoutes,
      ...salesPersonRoutes,
      ...icdRoutes,
      ...invoiceRoutes,
      ...claimRouteRoutes,
      ...customerRoutes,
      ...auditLogRouteRoutes,
      new Route({
            getParentRoute: () => rootRoute,
            path: 'not-authorized',
            component: NotAuthorizedPage,
        }),
     // ...providersRoutes
    // ...employeesRoutes,
    
  ]),
  // Add other router options here, like history, base path, etc.
});

// Register your router for type safety (important!)
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
